import React from "react";
import { Grid, Segment, Header, Icon, Message } from "semantic-ui-react";
import "./DashboardAlerts.scss";

export function DashboardAlerts(props) {
  const { alerts } = props;

  if (!alerts) return null;

  const hasAlerts =
    alerts.studentsLowAttendance > 0 ||
    alerts.overduePayments > 0 ||
    alerts.pendingJustifications > 0;

  if (!hasAlerts) return null;

  return (
    <Segment className="dashboard-alerts">
      <Header as="h3">
        <Icon name="warning sign" />
        Alertas Importantes
      </Header>
      <Grid stackable>
        <Grid.Row columns={3}>
          {alerts.studentsLowAttendance > 0 && (
            <Grid.Column>
              <Message warning>
                <Message.Header>
                  <Icon name="user times" />
                  Estudiantes en Riesgo
                </Message.Header>
                <p>
                  <strong>{alerts.studentsLowAttendance}</strong> estudiantes
                  con asistencia menor al 85%
                </p>
              </Message>
            </Grid.Column>
          )}
          {alerts.overduePayments > 0 && (
            <Grid.Column>
              <Message negative>
                <Message.Header>
                  <Icon name="exclamation triangle" />
                  Pagos Vencidos
                </Message.Header>
                <p>
                  <strong>{alerts.overduePayments}</strong> pagos con más de 30
                  días de retraso
                </p>
              </Message>
            </Grid.Column>
          )}
          {alerts.pendingJustifications > 0 && (
            <Grid.Column>
              <Message info>
                <Message.Header>
                  <Icon name="file alternate" />
                  Justificaciones Pendientes
                </Message.Header>
                <p>
                  <strong>{alerts.pendingJustifications}</strong>{" "}
                  justificaciones por revisar
                </p>
              </Message>
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
